import axios from 'axios';

// Use localhost in development, relative path in production
// Relative path works for both kanban.ufc.dp.ua and kanban-test.ufc.dp.ua
const baseURL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8080/'
  : '/';

const instance = axios.create({
  baseURL: baseURL
});

instance.CancelToken = axios.CancelToken;
instance.cancelToken = axios.cancelToken;
instance.isCancel = axios.isCancel;
instance.defaults.headers.common['Authorization'] = '';

export default instance;




// WEBPACK FOOTER //
// ./src/axios-trips.js